



















































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { UserStore } from '@/store/modules/user';
import { AppStore } from '@/store/modules/app';
import { setUserAccount, removeUserAccount, getUserAccount } from '@/utils/auth';
import { login, checkVerifyCode, generateVerificationCode, modifyPhone } from '@/api/user';
import axios from 'axios';
import { emptyRule } from '@/utils/rules';

@Component
export default class Login extends Vue {
  showPwd: boolean = false;
  verificationCodeImage: any = ''; //'/api/Account/GenerateVerificationCode?userName=13800138000';
  verificationCode: string = '';
  userName: string = ''; //'13800138000';
  password: string = ''; //'138000';
  /**是否记住用户名 */
  rememberUserName: boolean = false;
  /**显示或隐藏验证码 */
  showVerifyCode: boolean = false;
  /**登录按钮loading状态 */
  loading: boolean = false;
  /**用户名规则 */
  nameRules: Array<any> = [(v: any) => !!v || '账号不能为空'];
  /**密码规则 */
  pwdRules: Array<any> = [(v: any) => !!v || '密码不能为空'];

  mounted() {}

  created() {
    let account = getUserAccount();
    if (account != undefined) {
      this.userName = account;
      this.rememberUserName = true;
    }
  }

  /**验证码规则 */
  get codeRules() {
    const rules = [];
    if (this.showVerifyCode) {
      rules.push(emptyRule('验证码'));
    }
    return rules;
  }

  OnKeyup(event: any) {
    //回车事件
    if (event.keyCode == 13) {
      event.target.blur();
      this.login();
    }
  }

  /**登录 */
  login() {
    this.loading = true;
    // setTimeout(() => {
    //   UserStore.Login({ username: this.userName, password: this.password });
    //   this.$router.push('/');
    // }, 1000);

    if ((this.$refs.loginForm as any).validate()) {
      let _this = this;
      login(this.userName, this.password, this.verificationCode)
        .then((response: any) => {
          _this.loading = false;

          // console.log(response);
          //response.needVerificationCode == true && !_this.showVerifyCode
          if (response.needVerificationCode == true) {
            _this.showVerifyCode = true;
            this.getVerifyCode();
          } else {
            let token = response.accessToken;

            _this.showVerifyCode = false;

            //判断是否要记住用户名
            if (_this.rememberUserName) {
              setUserAccount(_this.userName);
            } else {
              removeUserAccount();
            }
            UserStore.Login(token);
            UserStore.GetUserInfo().then((response: any) => {
              _this.$router.push('/');
            });
          }

          // if (response.isSuccess == true) {
          //   let token = response.accessToken;

          //   _this.showVerifyCode = false;

          //   //判断是否要记住用户名
          //   if (_this.rememberUserName) {
          //     setUserAccount(_this.userName);
          //   } else {
          //     removeUserAccount();
          //   }
          //   UserStore.Login(token);
          //   UserStore.GetUserInfo().then((response: any) => {
          //     _this.$router.push('/');
          //   });
          //   // UserStore.RoleList();
          // } else {
          //   //需要验证码
          //   if (response.needVerificationCode == true && !_this.showVerifyCode) {
          //     _this.showVerifyCode = true;
          //     this.getVerifyCode();
          //   } else {
          //     AppStore.ShowError(response.errorMessage);
          //   }
          // }
        })
        .catch((error: any) => {
          _this.loading = false;
          // console.log(error)
          //error.result && error.result.needVerificationCode == true && !_this.showVerifyCode
          if (error.result && error.result.needVerificationCode == true) {
            _this.showVerifyCode = true;
            this.getVerifyCode();
          }
        });
    } else {
      this.loading = false;
    }
  }

  /**点击了忘记密码 */
  onForgetPWDClick() {
    AppStore.ShowInfo('请联系管理员重置');
  }

  /**点击了验证码 */
  onClickVerigyCode() {
    this.verificationCodeImage = `/api/Account/GenerateVerificationCode?userName=${this.userName}&t=${Math.random()}`;
  }

  /**账号输入完成监听 */
  onNameBlur(value: any) {
    if (/^1[3-9][0-9]{9}$/.test(this.userName)) {
      checkVerifyCode(this.userName).then((response: any) => {
        if (response == true) {
          this.showVerifyCode = response;
          this.getVerifyCode();
        }
      });
    }
  }

  /**获取验证码 */
  getVerifyCode() {
    this.verificationCodeImage = `/api/Account/GenerateVerificationCode?userName=${this.userName}&t=${Math.random()}`;
  }

  /**密码输入的时候 */
  onPasswordInput(v: string) {
    this.$nextTick(() => {
      this.password = v.trim();
    });
  }
}
